export default "__VITE_PUBLIC_ASSET__92828a14__"